import api from '@motionelements/core/src/api/base-api-v2';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string.js';

const baseUrl = '/v2/artist/templates';

function fixParams(params) {
  params = params || {};

  // let fields = null;
  // if (_.has(params, 'fields')) {
  //   fields = params.fields;
  //   delete params.fields;
  // }

  params = snakeCaseKeys(params);

  // if (fields && _.size(fields)) {
  //   Object.keys(fields).forEach((key) => {
  //     params[`fields[${key}]`] = fields[key];
  //   });
  // }

  return params;
}

export const listPriceTemplates = async (params, axiosConfig) => {
  params = fixParams(params);
  params.type = 'price';

  // todo: hotfix for api not support param as array
  if (typeof params.media_type === 'object' && params.media_type.length === 1) {
    params.media_type = params.media_type[0];
  }

  const config = {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    ...(axiosConfig || {}),
  };
  return api.get(baseUrl, config);
};

export const deleteTemplate = id => api.request('delete', `${baseUrl}/${id}`);

// eslint-disable-next-line
export const listTemplates = (params, axiosConfig) => {
  return api.get(baseUrl, {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    ...(axiosConfig || {}),
  });
};

